import SortableTableHeader from '../../utils/SortableTableHeader';
import { Trans } from '@lingui/react';
import { getFileName, getFilteredAssetsAttributes, logDownload } from './ItemDataCategoryTableUtils';
import LimitText from '../../utils/LimitText';
import React from 'react';
import filesize from 'filesize';
import { useAssetPreviews } from '../../../hooks/useAssetPreviews';

const RenderFileList = ({
    data,
    stateSortBy,
    stateSortDirection,
    user,
    toggleSort,
    getSorting
}) => {
    const {
        onClick,
        showPreview
    } = data

    // Per prendere le immagini di anteprima uso l' hook custom che ho creato apposta, l' useAssetPreviews
    const filteredAssets = getFilteredAssetsAttributes(data, stateSortBy, stateSortDirection);
    const { previewImages, loading, error } = useAssetPreviews(filteredAssets);

    if (showPreview) {
        return (
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 pt-2">
                {getFilteredAssetsAttributes(data, stateSortBy, stateSortDirection).map((attr, i) => {
                    // console.log(attr);

                    return (
                        <div key={i} className="p-2 bg-slate-200 rounded">
                            <div className="flex items-center cursor-pointer min-h-[140px]">
                                {previewImages[attr.src] && (
                                <img
                                    className="img-responsive"
                                    // src={this.getFileThumbnailPath(attr.filename)}
                                    src={previewImages[attr.src]}
                                    alt={getFileName(attr.filename)}
                                    onClick={() => onClick(i)}
                                    style={{
                                        maxHeight: '140px',
                                        margin: 'auto auto',
                                    }}
                                />
                                    )
                                }
                            </div>
                            <div className="m-0">
                                <div
                                    className="text-primary"
                                    title={getFileName(attr.filename)}
                                    style={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {getFileName(attr.filename)}
                                </div>
                                <div className="flex">
                                    <div className="grow">
                                            <span>
                                                <Trans id="ext" />: {attr.ext}
                                                <br />
                                                {attr.size && (
                                                    <>
                                                        <Trans id="weight" />:{' '}
                                                        {filesize(attr.size, {
                                                            separator: ',',
                                                            base: 10,
                                                        })}
                                                    </>
                                                )}
                                            </span>
                                    </div>
                                    <div>
                                        <a
                                            className="btn btn-primary"
                                            title="Download"
                                            href={attr.src}
                                            onClick={() => logDownload(data, user, attr.filename)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="icon icon-download" />
                                        </a>
                                    </div>
                                </div>
                                <div className="text-bold">
                                    <LimitText
                                        limit={20}
                                        text={attr.description !== '-' ? attr.description : ''}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    return (
        <table className="table table-striped table-striped-alt table-hover table-dense">
            <thead>
            <tr>
                <SortableTableHeader
                    attr="label"
                    onClick={toggleSort}
                    sorting={getSorting}
                    headerStyle={{ width: '312px' }}
                >
                    <Trans id={data.category.classLabel} />
                </SortableTableHeader>
                <SortableTableHeader
                    attr="filename"
                    onClick={toggleSort}
                    sorting={getSorting}
                    headerStyle={{ width: '200px' }}
                >
                    <Trans id="file:name" />
                </SortableTableHeader>
                <SortableTableHeader
                    attr="description"
                    onClick={toggleSort}
                    sorting={getSorting}
                    headerStyle={{ width: '380px' }}
                >
                    <Trans id="description" />
                </SortableTableHeader>
                {/* <th style={{ width: '200px' }}>
                            <Trans id="file:name" />
                        </th>
                        <th style={{ width: '380px' }}>
                            <Trans id="description" />
                        </th>*/}
                <th style={{ width: '120px' }} className="text-center">
                    <Trans id="download" />
                </th>
            </tr>
            </thead>
            <tbody>
            {getFilteredAssetsAttributes(data, stateSortBy, stateSortDirection).map((attr, i) => (

                <tr key={i}>
                    <td>
                        <LimitText limit={30} text={attr.label} textClass="tooltip-right" />
                    </td>
                    {/* <td>{attr.ext}</td>
                            <td>
                                {attr.size
                                    ? filesize(attr.size, {
                                          separator: ',',
                                          base: 10
                                      })
                                    : '-'}
                            </td> */}
                    <td>
                        <LimitText limit={40} text={getFileName(attr.filename)} />
                    </td>
                    <td>
                        <LimitText limit={100} text={attr.description} />
                    </td>
                    <td className="text-center">
                        <a
                            className="btn btn-action btn-link"
                            title="Download"
                            href={attr.src}
                            onClick={() => logDownload(data, user, attr.filename)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i className="icon icon-download" />
                        </a>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}

export default RenderFileList
